import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import CreateVendor from "./createVendor";
import VendorManagement from "./vendorManagement";
import "../../../../styles/userManagement.css";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";

function UserManagement() {
  const [currentTab, setCurrentTab] = useState(0);
  const [vendors, setVendors] = useState([]);
  const [vendorBusinessUnitList, setVendorBusinessUnitList] = useState([]);
  const [vendorSubBusinessUnitList, setVendorSubBusinessUnitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorsList, SetVendorList] = useState([]);
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllBusinessUnitList } = useHttp();
  const { sendRequest: getAllSubBusinessUnitList } = useHttp();
  const { sendRequest: deleteVendorRecord } = useHttp();
  const { sendRequest: updateRecordById } = useHttp();
  const { sendRequest: getSelectedThirdPartyDetails } = useHttp();
  useEffect(() => {
    getVendorListData();
    getBusinessUnitList();
    getSubBusinessUnitList();
    getAllVendors();
  }, []);

  const getVendorListData = async () => {
    getSelectedThirdPartyDetails(APIService.getSelectedThirdPartyDetails(), (data) => {
      setVendors(data.MSG);
    })
  };
  const getAllVendors = async () => {
    getAllVendorList(APIService.getAllVendorListAdmin(), (result) => {
      SetVendorList(result.MSG)
    })
  };
  const getBusinessUnitList = async () => {
    getAllBusinessUnitList(APIService.getAllBusinessUnitList(), (data) => {
      setVendorBusinessUnitList(data.MSG);
    })
  };
  const getSubBusinessUnitList = async () => {
    getAllSubBusinessUnitList(APIService.getAllSubBusinessUnitList(), (data) => {
      setVendorSubBusinessUnitList(data.MSG);
    })
  };
  const ChangeTab = (id) => {
    setCurrentTab(id);
  };
  const handleTabs = (v) => {
    setCurrentTab(v);
  };

  const handleDelete = async (vendorId,vendorUserId, setModalVisible, setSearch) => {

    setLoading(true);
    try {
      const email=sessionStorage.getItem("email");
      deleteVendorRecord(APIService.deleteVendorRecord(vendorId, vendorUserId,email), () => {
        if (result.CODE) {
          setLoading(false);
          setModalVisible(false);
          setSearch("");
          displayToastMessage(result.MSG, "success");
          getVendorListData();
        } else {
          setLoading(false);
          setModalVisible(false);
          setSearch("");
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      setLoading(false);
      setModalVisible(false);
      setSearch("");
      displayToastMessage("Something went wrong!", "error");
    }
  };

  const responseHandlerUpdate = (result) => {
    if (result.CODE) {
      displayToastMessage(result.MSG, "success");
      getVendorListData();
      setLoading(false);
    } else {
      setLoading(false);
      displayToastMessage(
        "Something went wrong, Please try again!",
        "error"
      );
    }
  }

  const errorHandlerUpdate = () => {
    setLoading(false);
    displayToastMessage("Something went wrong, Please try again!", "error");
  }

  const updateVendorDetailsById = async (data) => {
    setLoading(true);
    updateRecordById(APIService.updateRecordById(data), responseHandlerUpdate, errorHandlerUpdate)
  };
  return (
    <div className="user-management-container">
      <Tabs
        activeIndex={currentTab}
        onTabChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="view" label="Third Party Management">
          <VendorManagement
            Vendors={vendors}
            reload={getVendorListData}
            handleDelete={handleDelete}
            updateVendorDetailsById={updateVendorDetailsById}
            loading={loading}
            VendorBusinessUnitList={vendorBusinessUnitList}
            VendorSubBusinessUnitList={vendorSubBusinessUnitList}
          />
        </Tab>
        <Tab value="create" label="Create Third Party Account">
          <CreateVendor
            SetTab={setCurrentTab}
            getVendorListData={getVendorListData}
            Vendors={vendorsList}
            VendorBusinessUnitList={vendorBusinessUnitList}
            VendorSubBusinessUnitList={vendorSubBusinessUnitList}
          />
        </Tab>
      </Tabs>
    </div>
  );
}
export default UserManagement;
